export const getParamsFromLocalStorage = () => {
    const searchParamsString = localStorage.getItem('searchParams')
    if (searchParamsString) {
        return new URLSearchParams(searchParamsString)
    }
    return new URLSearchParams()
}
